import React from 'react'
import Style from './NotFound.module.css'
import img from '../../assets/images/error.svg'
export default function NotFound() {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <img className='w-75' src={img} alt="Not Found" />
    </div>
  )
}
